/**
 * Registers the My Money Hero service worker on supported browsers.
 * Runs after window load so it doesn't block first paint.
 *
 * Dev note: React dev server (CRACO) serves `/service-worker.js` directly
 * from /public, so registration works in both dev and production bundles.
 */
export function registerServiceWorker() {
  if (typeof window === "undefined") return;
  if (!("serviceWorker" in navigator)) return;

  // Never register the SW on localhost during local dev unless explicitly enabled
  const isLocalhost = /^(localhost|127\.0\.0\.1|\[::1\])$/.test(window.location.hostname);
  const enableInDev = process.env.REACT_APP_PWA_ENABLE_DEV === "true";
  if (isLocalhost && !enableInDev) return;

  window.addEventListener("load", () => {
    navigator.serviceWorker
      .register("/service-worker.js", { scope: "/" })
      .catch((err) => {
        // Silent in production; non-fatal
        if (process.env.NODE_ENV !== "production") {
          // eslint-disable-next-line no-console
          console.warn("SW registration failed:", err);
        }
      });
  });
}
